$(".imagenes_perfil").on('change',function(){
    var archivo=$(this)[0].files;
    $("#img_"+$(this)[0].name).attr('src',URL.createObjectURL(archivo[0]));
});

eliminarPerfil = function(tipo){
    $("#perfil_eliminar_tipo").val(tipo);

}
